import { CompanyType } from "../constants/company-type.enum";

export function constitutionalDocumentTitle(opfCode: CompanyType | undefined): string {
  if ([CompanyType.LLP, CompanyType.LPA, CompanyType.GPA].includes(opfCode!)) {
    return 'Partnership Agreement';
  }
  if (opfCode === CompanyType.NPI) {
    return 'Charter';
  }
  if (opfCode === CompanyType.FOU) {
    return 'Constitution of the Foundation';
  }
  return 'Articles of Association';
}
